import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { http } from "@/lib/api";

// BE-10: the previous version issued a GET which the backend USED to delete
// the subscription. Link-preview scanners fetch every URL in inbound email,
// so real recipients were silently unsubscribed. Now:
//   1) GET /api/unsubscribe returns a preview (no mutation)
//   2) The user confirms with a button, which POSTs the delete.
export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [subject, setSubject] = useState(null);
  const token = params.get("token") || "";
  useEffect(() => {
    if (!token) { setState("invalid"); return; }
    http.get(`/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => { setSubject(r.data); setState("confirm"); })
      .catch(() => setState("invalid"));
  }, [token]);

  const confirmUnsub = async () => {
    setState("submitting");
    try {
      await http.post(`/unsubscribe?token=${encodeURIComponent(token)}`);
      setState("ok");
    } catch {
      setState("invalid");
    }
  };

  return (
    <div className="bp-container py-24 text-center max-w-xl">
      {state === "loading" && (
        <div className="animate-pulse h-6 w-40 bg-neutral-200 mx-auto" data-testid="unsub-loading" />
      )}
      {state === "confirm" && (
        <>
          <h1 className="font-serif text-4xl mb-4" data-testid="unsub-confirm-heading">
            Confirm your unsubscribe
          </h1>
          {subject && subject.kind === "brand" && (
            <p className="mb-6 text-sm" style={{ color: "var(--bp-text-muted)" }}>
              Removes future BrandPassport updates for this brand from {subject.email || "your address"}.
            </p>
          )}
          {subject && subject.kind === "sector" && (
            <p className="mb-6 text-sm" style={{ color: "var(--bp-text-muted)" }}>
              Removes sector notifications ({subject.sector_code}) from {subject.email || "your address"}.
            </p>
          )}
          <button
            onClick={confirmUnsub}
            className="px-5 py-2 bg-black text-white"
            data-testid="unsub-confirm-button"
          >
            Yes, unsubscribe me
          </button>
        </>
      )}
      {state === "submitting" && (
        <h1 className="font-serif text-4xl" data-testid="unsub-submitting">Unsubscribing…</h1>
      )}
      {state === "ok" && (
        <h1 className="font-serif text-4xl" data-testid="unsub-ok">Unsubscribed</h1>
      )}
      {state === "invalid" && (
        <h1 className="font-serif text-4xl" data-testid="unsub-invalid">
          Invalid or already unsubscribed
        </h1>
      )}
    </div>
  );
}
